import { Component, OnInit } from '@angular/core';
import { HCPService } from '../hcp.service';
import { forkJoin } from 'rxjs';
import { DisplayModes } from '../../../models/enums';
import { ActivityApprovalActorType, ActivityTypeApproval } from '../../../models/lookups/activityType.model';
import { Role } from '../../../models/role.model';
import { UserMini } from '../../../models/user-mini.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { UsersApiService } from '../../../services/users-api.service';
import { AppTranslationService } from '../../../services/app-translation.service';

@Component({
  selector: 'crm-hcp-approval-cycle',
  templateUrl: './hcp-approval-cycle.component.html',
  styleUrls: ['./hcp-approval-cycle.component.css']
})
export class HcpApprovalCycleComponent implements OnInit {

  approvalCycle: any[] = [];
  activityApprovalActorTypes = ActivityApprovalActorType;
  activityApprovalActorkeys: any[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  users: UserMini[] = [];
  roles: Role[] = [];
  jobs: any[] = [{ id: 1, name: '1st direct manager' }, { id: 2, name: '2nd direct manager' }, { id: 3, name: '3rd direct manager' }, { id: 4, name: '4th direct manager' }]


  constructor(private readonly hcpService: HCPService, private translateService: AppTranslationService,
    private usersService: UsersApiService, private accountService: AccountService, private alertService: AlertService) { }

  ngOnInit() {
    let keys = Object.keys(ActivityApprovalActorType).filter(f => !isNaN(Number(f)));
    for (let i = 1; i <= keys.length; i++) {
      this.activityApprovalActorkeys.push({ name: this.activityApprovalActorTypes[i], value: i });
    }

    forkJoin(
      this.accountService.getAllRoles(),
      this.usersService.getAllUsersMiniReport())
      .subscribe(([response1, response2]) => {
        this.displayMode = DisplayModes.Success;
        this.roles = response1 as Role[];
        this.users = response2 as UserMini[];

        this.getApprovalCycle();
      }, error => {
        this.displayMode = DisplayModes.Success;
        this.alertService.showStickyMessage("Load Data Error", "The below errors occured whilst fetch data from server:", MessageSeverity.Error, error);
        this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
      });

  }

  getApprovalCycle() {
    this.hcpService.getHcpApprovalCycle().subscribe((res: any) => {
      if (res && res.approvalCycle) {
        this.approvalCycle = res.approvalCycle;

        this.approvalCycle.forEach(x => {

          if (x.activityApprovalActorType == ActivityApprovalActorType.User) {
            x.showUsers = true;
            x.activityApprovalActorValueData = this.users.find(y => y.id == x.activityApprovalActorValue);
          }
          else if (x.activityApprovalActorType == ActivityApprovalActorType.Role) {
            x.showRoles = true;
            x.activityApprovalActorValueData = this.roles.find(y => y.id == x.activityApprovalActorValue);
          }
          else if (x.activityApprovalActorType == ActivityApprovalActorType.Job) {
            x.showJobs = true;
            x.activityApprovalActorValueData = this.jobs.find(y => y.id == x.activityApprovalActorValue);
          }
          x.activityApprovalActorTypeData = this.activityApprovalActorkeys.find(y => y.value == x.activityApprovalActorType)
        })

      }
    });
  }


  removeLevel(index) {
    this.approvalCycle.splice(index, 1);
  }
  addNewLevel() {
    if (!this.approvalCycle)
      this.approvalCycle = [];
    this.approvalCycle.push(new ActivityTypeApproval());
  }

  save() {
    if (this.approvalCycle) {
      this.approvalCycle.forEach(x => x.activityApprovalActorValue = x.activityApprovalActorValueData.id)
    }
    let obj = { approvalCycle: this.approvalCycle };
    this.displayMode = DisplayModes.Loading;
    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
    this.hcpService.saveHcpApprovalCycle(obj).subscribe((res: any) => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("SavedSuccessfully"), MessageSeverity.Success);
    }, err => {

      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("Error"), MessageSeverity.Error);
    });
  }

  onChangeApprovalActorType(level: ActivityTypeApproval) {
    if (level.activityApprovalActorTypeData.value == ActivityApprovalActorType.User) {
      level.showRoles = false;
      level.showJobs = false;
      level.showUsers = true;
      level.activityApprovalActorValueData = null;
      level.activityApprovalActorType = ActivityApprovalActorType.User;
    }
    else if (level.activityApprovalActorTypeData.value == ActivityApprovalActorType.Role) {
      level.showRoles = true;
      level.showJobs = false;
      level.showUsers = false;
      level.activityApprovalActorValueData = null;
      level.activityApprovalActorType = ActivityApprovalActorType.Role;
    }
    else if (level.activityApprovalActorTypeData.value == ActivityApprovalActorType.Job) {
      level.showRoles = false;
      level.showJobs = true;
      level.showUsers = false;
      level.activityApprovalActorValueData = null;
      level.activityApprovalActorType = ActivityApprovalActorType.Job;
    }


  }


}
